import UserTableDto from 'app/admin/user/dto/UserTableDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import PiMeasurementReaderTableDto from '../dto/PiMeasurementReaderTableDto';

class PiMeasurementReaderTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'piMeasurementReaderTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<PiMeasurementReaderTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, PiMeasurementReaderTableDto)))
				.catch(reject);
		});
	}
}

export default new PiMeasurementReaderTableService();
